import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const formatIssues = (list) => (list || []).map(row => ({
    id: row.id,
    project: row.project,
    product: row.product,
    summary: row.summary,
    balises: Array.isArray(row.balises) ? row.balises.join(', ') : row.balises,
    reporter: row.reporter,
    handler: row.handler,
    changeLog: row.changeLog,
    version: row.version,
    dateSubmitted: row.date_submitted ?? row.dateSubmitted ?? row.last_updated,
}))

const initialState = {
    status: STATUS.IDLE,
    byId: {},
    allIds: [],
}

const VersionsSlice = createAppSlice({
    name: 'versions',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),
        fetch: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.support.versions())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des versions')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    const formatted = formatIssues(action.payload)
                    const byId = keyBy(formatted, 'id')
                    state.byId = byId
                    state.allIds = formatted.map(i => i.id)
                },
                options: {
                    condition: (_, { getState }) => {
                        const state = getState()
                        return state.supervision?.versions?.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            },
        ),
    }),
    selectors: {
        selectVersions: (state) => state.allIds.map(id => state.byId[id]),
    },
})

export const VersionsActions = VersionsSlice.actions
export const { selectVersions } = VersionsSlice.getSelectors((state) => state.supervision.versions)
export default VersionsSlice
